//--------------- IMPORTAÇÕES ---------------//
import { createCompanyService, updateCompanyService, loadCompaniesService } from "../services"
import { EmpresasContext } from "../context/EmpresasContext";
import { useContext } from "react";
import { LoadingContext } from "../../../shared/context/LoadingContext";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerCreateCompany() {
    


    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { empresas, setEmpresas } = useContext(EmpresasContext);
    const { formData, setFormData } = useContext(EmpresasContext);
    const { isEditing, setIsEditing } = useContext(EmpresasContext);
    const { editedCompanyId, setEditedCompanyId } = useContext(EmpresasContext);
    const { isLoading, setIsLoading } =  useContext(LoadingContext);


    
    //--------------- FUNÇÃO ASSÍNCRONA HANDLE SAVE COMPANY ---------------//
    // Responsável por salvar a empresa criada via API
    // Após salvar, os Estados "formData","isEditing" e "editingId" são reinicializados para os valores padrão
    // Por fim, atualiza a lista de empresas para aparecer a nova empresa 
    async function handleSaveCompany() {
        if (isEditing) {
            await updateCompanyService(editedCompanyId, formData)
        } else {
            await createCompanyService(formData);
        }
        setFormData({ nome: "", descricao_negocio: "" });
        setIsEditing(false);
        setEditedCompanyId(null);
        handleRefreshCompanies();
    }



    //--------------- FUNÇÃO ASSÍNCRONA HANDLE REFRESH COMPANIES ---------------//
        async function handleRefreshCompanies() {
            setIsLoading(true);
            const response = await loadCompaniesService();
            if (response) {
                setEmpresas(response.data);
            }
            setIsLoading(false);
        }


    
    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV CRIAR/EDITAR EMPRESA */}
            <div className="mb-4 flex flex-col gap-2 w-full sm:max-w-2xl">

                <div className="flex gap-2">
                    {/* INPUT DO NOME DA NOVA EMPRESA */}
                    <input
                        type="text"
                        placeholder="Nome da empresa"
                        className="bg-surface-2 border border-white/[0.08] p-2 rounded text-white flex-1 max-w-[45vw] sm:max-w-none"
                        value={formData.nome || ""}
                        onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                    />

                    {/* BUTTON CRIAR/ATUALIZAR EMPRESA */}
                    <button
                        onClick={handleSaveCompany}
                        className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
                    >
                        {isEditing ? "Atualizar" : "Criar"}
                    </button>
                </div>

                {/* TEXTAREA DESCRIÇÃO DO NEGÓCIO (Fase 2 — usado pelo agente IA como contexto) */}
                <textarea
                    placeholder="Descrição do negócio (opcional) — o agente de IA usa esse texto como contexto da empresa nas respostas"
                    className="bg-surface-2 border border-white/[0.08] p-2 rounded text-white text-sm w-full min-h-[88px] resize-y"
                    value={formData.descricao_negocio || ""}
                    onChange={(e) => setFormData({ ...formData, descricao_negocio: e.target.value })}
                />

            </div>

        </>
    )
}